import type {
  AssetFragment,
  DefaultImageUrlTransformationFragment,
  InlineBannerImageUrlTransformationFragment,
  PrimaryBannerImageUrlTransformationFragment,
} from '@seek/cmsu-cms-connect';
import React, { useState, type CSSProperties, useEffect } from 'react';

type Props = Pick<AssetFragment, 'alt'> &
  Pick<
    | DefaultImageUrlTransformationFragment
    | PrimaryBannerImageUrlTransformationFragment
    | InlineBannerImageUrlTransformationFragment,
    'url'
  > & {
    style?: CSSProperties;
  };

export const Asset = ({ url, alt, style }: Props) => {
  const [src, setSrc] = useState<string>();

  useEffect(() => {
    const validateUrl = async () => {
      const isValid = await isValidUrl(url);
      if (isValid) {
        setSrc(url);
      } else {
        setSrc(url.replace(/(https:\/\/[^/]+)\/[^/]+\//, '$1/'));
      }
    };
    validateUrl();
  }, [url]);

  return (
    <img
      data-testid="assetTestId"
      src={src}
      alt={alt || undefined}
      style={{
        maxWidth: '100%',
        maxHeight: '100%',
        ...style,
      }}
    />
  );
};

const isValidUrl = async (url: string) => {
  const res = await fetch(url, { method: 'HEAD' });
  return res.status === 200;
};
